import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-daserste',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Das Erste icon</title><path d="M11.646.005C5.158.2-.001 5.57 0 12.127.135 18.724 5.468 24 12 24s11.865-5.276 12-11.873C24.001 5.291 18.41-.195 11.645.005zm5.138 4.93V16.96L8.78 19.92v-9.08l-3.9 1.386V9.263l11.903-4.328z"/></svg>`,
    styles: []
})
export class SimpleIconsDasersteComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#001A4B';
    @Input() className: string = 'simple-icons-daserste'
    constructor() {}
    ngOnInit(): void {}
}
